export interface Day {
  name: string;
  day: number;
  longName: string;
  date: Date;
  today: boolean;
}
